import { render, staticRenderFns } from "./vc-skeleton.vue?vue&type=template&id=1d09a456&scoped=true&"
import script from "./vc-skeleton.vue?vue&type=script&lang=js&"
export * from "./vc-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./vc-skeleton.vue?vue&type=style&index=0&id=1d09a456&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d09a456",
  null
  
)

export default component.exports